"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverviewOwnershipContainer = void 0;
var React = require("react");
var charts_1 = require("./charts");
var container_1 = require("./container");
var App_1 = require("../../App");
var OverviewOwnershipContainer = (function (_super) {
    __extends(OverviewOwnershipContainer, _super);
    function OverviewOwnershipContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewOwnershipContainer.prototype.render = function () {
        return (React.createElement(container_1.Container, { borderless: true },
            React.createElement(charts_1.MultiBarHorizontalChart, { data: this.props.data, heightModifier: 50, showLegend: true, onElementClick: this.onElementClick, showXAxis: true, showYAxis: false, showTooltip: true, xAxisWide: true })));
    };
    OverviewOwnershipContainer.prototype.onElementClick = function (obj) {
        App_1.store.editableListDialog.openDialog(obj.data.label, obj.data);
    };
    return OverviewOwnershipContainer;
}(React.Component));
exports.OverviewOwnershipContainer = OverviewOwnershipContainer;
